import * as PropTypes from 'prop-types';
import * as React from 'react';
import ProductBundle from './product_bundle';
import UrlHelpers from '../shared/url_helpers';
import { Tracker, APIRequest } from '@reverbdotcom/discovery-ui';

const BUNDLE_VIEWED_EVENT = 'product_bundle';
const UPSELL_VIEWED_EVENT = 'upsell_bundle';

class Promo extends React.Component {
  constructor() {
    super();
    this.state = { productBundle: { bundled_products: [] } };
  }

  componentDidMount() {
    this.fetchProductBundle();
  }

  fetchProductBundle() {
    APIRequest.get(UrlHelpers.productBundlePath(this.props.productId))
      .done((response) => {
        if (!response) { return; } // we return a 204 in some scenarios, for which we get no response object
        this.setState({ productBundle: response });
        if (response.id) {
          this.trackEvent(response, BUNDLE_VIEWED_EVENT);
        } else if (response.bundled_products) {
          this.trackEvent(response, UPSELL_VIEWED_EVENT);
        }
      });
  }

  trackEvent(bundle, eventType) {
    Tracker.view({
      name: eventType,
      type: 'listings',
      ids: bundle.bundled_products.map(l => l.id),
    });
  }

  get bundledProducts() {
    if (!this.state.productBundle.bundled_products) {
      return [];
    }
    return this.state.productBundle.bundled_products;
  }

  render() {
    if (!this.bundledProducts.length) { return false; }

    return (
      <div className="module bd-rounded mb-2">
        <ProductBundle
          productBundle={this.state.productBundle}
        />
      </div>
    );
  }
}

Promo.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Promo;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/promo.jsx